import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperPagination from '@/components/ui/swiper/swiper-pagination';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
// import "swiper/css/pagination";
import 'swiper/css/navigation';

import { Pagination } from 'swiper/modules';
import SectionTitle from '@/components/ui/section-title';

import ImageCard from '@/components/ui/image_card/imgCard';

import { MEDIA_BASE_URL } from '@/utils/api';
import { useState } from 'react';

const Faces = ({ facesData }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  const [num, setNum] = useState(0);
  const [selectedValue, setSelectedValue] = useState('');

  const data = [
    { size: '1000 x 1000' },
    { size: '1200 x 1200' },
    { size: '300 x 300' },
    { size: '300 x 400' },
    { size: '800 x 800' },
    { size: '800 x 1200' },
    { size: '250 x 375' },
    { size: '145 x 600' },
  ]

  const handleChange = (event) => {

    setSelectedValue(event.target.value);
  };


  return (
    <section>
      <div className="container">
        <SectionTitle
          title={'Faces'}
          customClass={'text-center mb-5 lg:mb-[2.5vw]'}
        />

        <div className="flex gap-5 justify-center items-center mb-4">
          <div className='hidden lg:block font-semibold pe-5 py-1 border-r border-black text-black'>
            Select Sizes in mm :
          </div>
          <div className="hidden lg:flex gap-2 items-center ">

            {
              data?.map((itemNew, i) => (<div key={i} className={num == i ? 'border border-black py-1 px-3 rounded-[5px] text-black' : 'px-3'} onClick={() => setNum(i)}>{itemNew.size}</div>))
            }

          </div>

          <div className="lg:hidden gap-2 items-center ">
            <select value={selectedValue} onChange={handleChange} className='border border-black py-1 px-3 rounded-[5px] text-black'>
              {
                data?.map((itemNew, i) => (i == 0 ? <option key={i} value="" disabled>Select Sizes in mm</option> : <option key={i} value={itemNew.size}>{itemNew.size}</option>))
              }
            </select>

          </div>
        </div>
        <div className="facesSlider">
          <Swiper
            slidesPerView={2}
            spaceBetween={10}
            speed={2000}
            loop={false}
            pagination={{
              clickable: true,
              el: '.faces-pagination',
            }}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            modules={[Pagination]}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            className="h-full"
          >
            {facesData.map((item, i) => (
              <SwiperSlide key={i} className="h-full">
                <ImageCard imgSrc={`${mediaBaseUrl}${item.image}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="relative z-10">
          <SwiperPagination
            customClass={
              'faces-pagination relative w-full h-[auto] lg:!top-[0vw] !mt-0'
            }
          />
        </div>
      </div>
    </section>
  );
};

export default Faces;
